import {useTranslation} from "react-i18next";
import "moment-timezone";
import ManagerSensorsTable from "./models/table/ManagerSensorsTable";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableSensors = ({items, itemsShow, buttonsTB, setButtonsTB, checkAll, setCheckAll, orderingRef}) => {
    const {t: _Tt} = useTranslation("tables");
    const {t: _Tc} = useCustomTranslation(translations);

    const stickyCellStyle = {
        position: "sticky",
        top: "164px",
        backgroundColor: "white",
        zIndex: 899,
    };

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.delete.disabled = items.current.chosen.length === 0;
        buttons.edit.disabled = items.current.chosen.length !== 1;
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "164px",
        backgroundColor: "white",
    };

    return (
        <table className="table table-striped sticky-horizontal">
            <thead>
                <tr>
                    <th
                        className="sticky-top border-bottom-sticky"
                        key="-1"
                        style={{
                            width: "0.4%",
                            verticalAlign: "bottom",
                            ...stickyCellStyle,
                        }}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                    <th
                        className="text-center sticky-top border-bottom-sticky"
                        style={{verticalAlign: "bottom", ...stickyCellStyle}}>
                        {_Tt("common.params")}
                    </th>
                </tr>
            </thead>
            <tbody id="data-list">
                {itemsShow.map((item) => (
                    <tr key={item.id} data-idx={item.id} onChange={onClick}>
                        <td style={{verticalAlign: "middle"}}>
                            <input
                                type="checkbox"
                                name="checkboxOpModes"
                                key={item.id}
                                data-idx={item.id}
                                defaultChecked={items.current.chosen.includes(item.id)}
                                readOnly={true}
                            />
                        </td>
                        <td style={{verticalAlign: "middle"}}>{item.name}</td>
                        <td style={{verticalAlign: "middle"}}>{item.model}</td>
                        <td className="d-flex align-items-center">
                            <ManagerSensorsTable item={item} t={_Tc} />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableSensors;
